import SidebarData from 'components/shared/Sidebar/Sidebar-data';
import RoutePaths from './RoutePaths';

type IdType = string | number;

/**
 * Returns first route the user can access based on their permissions.
 * Mirrors sidebar visibility logic so landing page always matches menu.
 * Falls back to RoutePaths.Home if nothing matched (super admin / full access).
 */
export const getFirstAccessiblePath = (permissions: string[], isSuperAdmin: boolean): string => {
  if (isSuperAdmin) return RoutePaths.Home;

  const hasModuleAccess = (moduleKey?: string): boolean => {
    if (!moduleKey) return true;
    const key = moduleKey.toLowerCase();
    return permissions.some((p) => {
      const pl = p.toLowerCase();
      return pl === `${key}.fullaccess` || pl.startsWith(`${key}.`);
    });
  };

  const first = SidebarData.main.find((item) => hasModuleAccess(item.permissionKey));
  return first?.path ?? RoutePaths.Home;
};

export const getNewPath = (path: RoutePaths | string): string => {
  return `${path}/new`;
};

export const getViewPath = (path: RoutePaths | string, id: IdType): string => {
  return `${path}/${id}`;
};

export const getEditPath = (path: RoutePaths | string, id: IdType): string => {
  return `${path}/${id}/edit`;
};
